export async function getUnitByChapterLTI(id){

    const options = { 
        method: 'POST', 
        headers: new Headers({ 
          'Content-Type': 'application/json',
          'sb-application-name': 'sb-site-ui',
          'sb-application-key': 'jmd-test',
          'sessionID' : sessionStorage.getItem("sessionID"),
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'Access-Control-Allow-Origin, Access-Control-Allow-Headers, Content-Type, sb-application-name, sb-application-key, sessionID ',
        }), 
        mode: 'cors',
        credentials: 'omit',
        // body: JSON.stringify(body)
      };
    
    const endpoint = process.env.REACT_APP_BFF + '/bff/v1.0/getUnitByChapter/'+id;
    options.method = 'GET';
  
    let sessionDetailsResponse =
      await fetch(endpoint,options)
        .then(response => {
        //   console.log(response);
          return response.json();
        })
        .catch(function(err) {
          console.log(err);
        });;

        // console.log("blah" + JSON.stringify(sessionDetailsResponse));

    return sessionDetailsResponse;

  }
